import * as angular from 'angular';

import { ComponentDefinition, IApiInformation} from '@models/index';

class ApiInformationController implements angular.IComponentController {
    readonly apiInformation: IApiInformation;
    static $inject = [];
}

export const wtApiInformation: ComponentDefinition = {
    componentId: 'wtApiInformation',
    controller: ApiInformationController,
    template: require('./apiInformation.component.html'),
    controllerAs: 'vm',
    bindings: {
        apiInformation: '<'
    }
};
